/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestionOption = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        label: {
    type: 'string',
    isRequired: true,
},
        value: {
    type: 'number',
    isRequired: true,
},
        order: {
    type: 'number',
    isRequired: true,
},
    },
};